import type { Ymaps3 } from './ymaps';
import { YANDEX_MAPS_SRC } from '../config/map';

let loadPromise: Promise<Ymaps3> | null = null;

function appendScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`);

    if (existing) {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', () => reject(new Error('Yandex Maps script failed to load')));
      return;
    }

    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.async = true;
    script.src = src;
    script.addEventListener('load', () => resolve());
    script.addEventListener('error', () => reject(new Error('Yandex Maps script failed to load')));

    document.body.append(script);
  });
}

export function loadYandexMaps(src: string = YANDEX_MAPS_SRC): Promise<Ymaps3> {
  loadPromise =
    loadPromise ??
    appendScript(src)
      .then(async () => {
        const ymaps3 = window.ymaps3;

        if (!ymaps3) throw new Error('Yandex Maps did not expose ymaps3');

        await ymaps3.ready;

        return ymaps3;
      })
      .catch((error: unknown) => {
        loadPromise = null;
        throw error;
      });

  return loadPromise;
}

export function resetYandexMapsLoader(): void {
  loadPromise = null;
}
